export { default } from '~/src/components/common-components/popup-content/popup-content';